export default "__VITE_ASSET__XVmhxcCU__"